// eslint-disable-next-line max-classes-per-file
import lcrRequest from '../lcrRequest';
import normalizeBetstop from './utils';

export class BetstopAPI {
  constructor(path, options) {
    const specifier = options.specifier === true
      ? '&specifier=live/all'
      : options.specifier === false
        ? '&specifier=prematch/all'
        : '&specifier=auto/all';

    this.url = `${path}&alias=${options.alias}&lang=${options.language}${specifier}`;
    this.matchId = options.matchId;
  }

  get() {
    return lcrRequest
      .get(this.url)
      .then(data => {
        if (!data || (data && data.error)) {
          throw data;
        }
        return normalizeBetstop(data, this.matchId);
      }).catch(e => {
        throw new Error(`Betstop API Request error: ${e}`);
      });
  }
}

export class BetstopConfigRequest extends BetstopAPI {
  constructor(matchId, specifier, alias, language) {
    super(`/api/odds-markets-info?match_id=${matchId}`, {
      matchId, specifier, alias, language,
    });
  }
}
